(function () {
	'use strict';
	var controllerId = 'elencoAvvisi';
	angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'avvisi', 'download', '$translate', elencoAvvisiFn]);

	function elencoAvvisiFn($scope, $uibModalInstance, avvisi, download, $translate) {
	    $scope.item = {};
	    $scope.filter = '';
		$scope.item.download = download;
		$scope.item.avvisi = avvisi;
		
		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
	}
})();